import { Component, Input, OnInit } from '@angular/core';
import { Address } from 'src/app/modules/route-planner/interfaces/location/address.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import {
  DESTINATION_POINT_LABEL,
  ORIGIN_POINT_LABEL,
  WAYPOINT_LABEL,
} from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    selector: 'app-addresses-details',
    templateUrl: './addresses-details.component.html',
    styleUrls: ['./addresses-details.component.scss'],
    standalone: false
})
export class AddressesDetailsComponent implements OnInit {
  @Input() origin: string;
  @Input() destination: string;
  @Input() stop: string;
  @Input() leg: string;
  /** When true, wrap route summary as an h2 (results headers); keep false for compact lists (e.g. favorites). */
  @Input() asRouteSummaryHeading = false;

  /**
   * Localized accessible names for the colored point icons.
   * The icons (filled yellow dot / empty yellow ring / yellow pin) visually
   * distinguish origin, intermediate stops and destination; SR users get the
   * role from these labels via role="img" + aria-label.
   */
  originPointLabel: string = ORIGIN_POINT_LABEL.english;
  destinationPointLabel: string = DESTINATION_POINT_LABEL.english;
  waypointLabel: string = WAYPOINT_LABEL.english;

  constructor(private readonly languageService: LanguageService) {}

  ngOnInit(): void {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.originPointLabel = ORIGIN_POINT_LABEL[language.language];
      this.destinationPointLabel = DESTINATION_POINT_LABEL[language.language];
      this.waypointLabel = WAYPOINT_LABEL[language.language];
    });
  }
}
